import axios from "../config/axios";
import Constants from "../data/Constants";

export const getMentorsList = async (pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.MENTOR.ALL).then((res) => {
    return res.data.result;
  });
};

export const getMentorSlots = async (id, pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.MENTOR.SLOTS + id).then((res) => {
    return res.data.result;
  });
};

export const deleteMentor = async (id) => {
  return await axios
    .delete(Constants.ENDPOINTS.MENTOR.DELETE + id)
    .then((res) => {
      return res.data.result;
    });
};

export const updateCounsellingSession = async (id, data) => {
  return await axios
    .patch(Constants.ENDPOINTS.MENTOR.COUNSELLING_SESSIONS_UPDATE + id, data)
    .then((res) => {
      return res.data.result;
    });
};

export const cancelCounsellingSession = async (id) => {
  return await axios
    .post(Constants.ENDPOINTS.MENTOR.CANCEL_COUNSELLING_SESSION + id)
    .then((res) => {
      return res.data.result;
    });
};

export const getMentorQuestions = async (mentorId, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.MENTOR.QUESTIONS + mentorId)
    .then((res) => {
      return res.data.result;
    });
};

export const updateMentorQuestion = async (questionId, body = {}) => {
  return await axios
    .patch(Constants.ENDPOINTS.QUESTION.UPDATE + questionId, body)
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleMentor = async (id, pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.MENTOR.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const getCounsellingSessions = async (filters = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.MENTOR.COUNSELLING_SESSIONS, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleMentor2 = async (id, pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.MENTOR.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const createSingleMentor = async (data, pagination = {}) => {
  const formData = new FormData();

  for (var key in data) {
    formData.append(key, data[key]);
  }

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await axios
    .post(Constants.ENDPOINTS.MENTOR.CREATE_SINGLE, formData, config)
    .then((res) => {
      return res.data.result;
    });
};

export const updateSingleMentor = async (id, data, pagination = {}) => {
  const formData = new FormData();

  for (var key in data) {
    formData.append(key, data[key]);
  }

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await axios
    .post(Constants.ENDPOINTS.MENTOR.UPDATE_SINGLE + id, formData, config)
    .then((res) => {
      return res.data.result;
    });
};
